// File: src/pages/EventRegisterPage.jsx
import React, { useState } from 'react';
import logoImg from '../assets/avt.png';

export default function EventRegisterPage() {
    const [email, setEmail] = useState('');
    const [fullName, setFullName] = useState(''); // Thêm state cho tên
    const [status, setStatus] = useState({ type: '', message: '' });
    const [isLoading, setIsLoading] = useState(false);

    const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) return;

        setIsLoading(true);
        setStatus({ type: '', message: '' });

        try {
            const res = await fetch(`${API_URL}/api/auth/event-register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                // TRUYỀN THÊM fullName XUỐNG BACKEND
                body: JSON.stringify({ email, fullName }) 
            });

            const data = await res.json();

            if (!res.ok) {
                throw new Error(data.message || 'Có lỗi xảy ra');
            }

            setStatus({ type: 'success', message: '🎉 Đăng ký thành công! Hãy kiểm tra Email nhé.' });
            
            // Xóa form
            setEmail('');
            setFullName(''); 
            
            setTimeout(() => setStatus({ type: '', message: '' }), 4000);

        } catch (error) {
            setStatus({ type: 'error', message: error.message });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="max-w-md w-full bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden transform transition-all">
                
                <div className="bg-white p-8 text-center border-b border-gray-100">
                    <img src={logoImg} alt="SkillMatch" className="w-20 h-20 mx-auto mb-4 drop-shadow-sm transform hover:scale-110 transition-transform" />
                    <h2 className="text-3xl font-extrabold text-gray-900 tracking-tight">Nhận Quà VIP</h2>
                    <p className="text-md text-gray-500 mt-2 font-medium">Từ hệ thống SkillMatch</p>
                </div>

                <div className="p-8 bg-white">
                    {status.message && (
                        <div className={`p-4 mb-6 rounded-xl text-sm font-bold text-center animate-fade-down ${status.type === 'success' ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'
                            }`}>
                            {status.message}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-5">
                        {/* Ô NHẬP TÊN */}
                        <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2">Họ và tên:</label>
                            <input
                                type="text"
                                required
                                value={fullName}
                                onChange={(e) => setFullName(e.target.value)}
                                placeholder="Nhập họ và tên của bạn"
                                className="w-full px-5 py-3 text-lg text-gray-900 bg-gray-50 border-2 border-gray-200 rounded-xl focus:border-blue-600 focus:bg-white transition-colors outline-none"
                                autoComplete="off"
                            />
                        </div>

                        {/* Ô NHẬP EMAIL */}
                        <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2">Email:</label>
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Nhập Email của bạn"
                                className="w-full px-5 py-3 text-lg text-gray-900 bg-gray-50 border-2 border-gray-200 rounded-xl focus:border-blue-600 focus:bg-white transition-colors outline-none"
                                autoComplete="off"
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={isLoading}
                            className="w-full py-4 mt-2 bg-blue-600 hover:bg-blue-700 text-white text-lg font-bold rounded-xl shadow-md transform transition-all hover:-translate-y-1 disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                        >
                            {isLoading ? (
                                <span className="material-symbols-outlined animate-spin">autorenew</span>
                            ) : (
                                '🎁 NHẬN QUÀ NGAY'
                            )}
                        </button>
                    </form>

                    <p className="text-center text-xs text-gray-400 mt-6">
                        Thông tin đăng nhập sẽ được gửi vào hộp thư của bạn.
                    </p>
                </div>
            </div>

            <style>{`
                @keyframes fadeDown { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }
                .animate-fade-down { animation: fadeDown 0.3s ease-out forwards; }
                @keyframes spin { 100% { transform: rotate(360deg); } }
                .animate-spin { animation: spin 1s linear infinite; }
            `}</style>
        </div>
    );
}